module.exports = __webpack_public_path__ + "img/header_bg.edff75e7.png";